import { render, staticRenderFns } from "./TabVerifyPayment.vue?vue&type=template&id=8c170d68&"
import script from "./TabVerifyPayment.vue?vue&type=script&lang=js&"
export * from "./TabVerifyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports